module.exports = __webpack_public_path__ + "img/master.b4261e2d.png";